import { render } from "./Communities.vue?vue&type=template&id=4250a045&scoped=true"
import script from "./Communities.vue?vue&type=script&lang=js"
export * from "./Communities.vue?vue&type=script&lang=js"

import "./Communities.vue?vue&type=style&index=0&id=4250a045&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4250a045"]])

export default __exports__